import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";
import { useTranslate } from "helpers";
import { OfferItemsAddedProps } from "./types";

import OfferItemsAddedChild from "./OfferItemsAddedChild";
import { FLEET_VEHICLE_OFFER_ITEMS_CHILD_SEARCH_COLUMNS, FLEET_VEHICLE_OFFER_ITEMS_SEARCH_COLUMNS } from "./consts";


const OfferItemsAdded: React.FC<OfferItemsAddedProps> = (props) => {
  const {
    items,
    isLoading,
    onEditClick,
    onDeleteClick
  } = props;

  const { t } = useTranslate();
  return (
    <>
      <TableSearch
        columns={FLEET_VEHICLE_OFFER_ITEMS_SEARCH_COLUMNS(t, onEditClick, onDeleteClick)}
        data={items}
        isLoading={isLoading}
        selectableRows={false}
        columnsChild={FLEET_VEHICLE_OFFER_ITEMS_CHILD_SEARCH_COLUMNS(t)}
        CustomTableRowChild={OfferItemsAddedChild}
      />
    </>
  );
};
export default memo(OfferItemsAdded);
